import {
  Alignment,
  Button,
  Classes,
  Dialog,
  FormGroup,
  HTMLSelect,
  HTMLTable,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc, IContestacao, IResultadoItem } from "../../model";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import CurrencyInput from "../utils/CurrencyInput";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import { MDBCol, MDBRow } from "mdbreact";
import { CalcSelect, filterCalcs, renderCalcs } from "../utils/CalcSelect";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";
const numeral = require("numeral");

interface Props {
  item: IResultadoItem;
  tipo: string;
  modelo: string;
  onClose: () => void;
  onCancel: () => void;
  sugerido_list: any;
}

interface State {
}

@observer
export class ContestarSugerido extends React.Component<Props, State> {

  obs = observable({
    contestacao: {} as IContestacao,
    memoria_salvar: false as boolean,
    alterar_data: false as boolean,
    calc_selecionado: null,
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean
  })

  constructor(props: any) {
    super(props);

    this.obs.calc_selecionado = this.props.sugerido_list.find(x => x.calc_id == this.props.item.calc_id)

    this.obs.contestacao = observable({
      nota_item_ids: [this.props.item.id],
      valor_contestado: parseFloat(this.props.item.valor_contestacao_icms) || 0,
      contestacao_data: null,
      motivo: this.props.item.motivo_contestacao_icms || "",
      contestacao_calc_id: null,
      mva: this.props.item.mva_usuario || null,
      entrada_saida: this.props.tipo.toLocaleLowerCase().replace("í", "i"),
      modelo: this.props.modelo.toLowerCase(),
    });
  }

  handleConfirm = async () => {

    let devolucao = false

    if (this.obs.alterar_data) {

      if (!this.obs.contestacao.contestacao_data) {
        toast.warning('Por favor, selecione uma data.', {});
        return;
      }

      if (this.obs.contestacao.motivo == "") {
        toast.error('Por favor, preencha o motivo da contestação!', {});
        return
      }

      delete this.obs.contestacao.contestacao_calc_id_devolucao
      this.obs.contestacao.contestacao_calc_id = this.obs.calc_selecionado._id

      devolucao = false

    } else {

      if (!this.obs.calc_selecionado._id) {
        toast.warning('Por favor, selecione um cálculo.', {});
        return;
      }

      if (this.obs.contestacao.mva == null) {
        toast.error('Por favor, preencha o MVA do produto ou Mude para Contestar Selecionados!', {});
        return
      }

      if (this.obs.contestacao.motivo == "") {
        toast.error('Por favor, preencha o motivo da contestação!', {});
        return
      }

      delete this.obs.contestacao.contestacao_calc_id_devolucao
      this.obs.contestacao.contestacao_calc_id = this.obs.calc_selecionado._id

      devolucao = false

    }

    await ResultadoStore.create_contestacao_task(this.obs.contestacao, this.obs.memoria_salvar, ResultadoStore.obs.empresaContestar.uf, devolucao, ResultadoStore.obs.empresaContestar.cnpj, ResultadoStore.obs.date_start, ResultadoStore.obs.date_end, this.obs.cnpj_memoria)

    ResultadoStore.consulta_resultados_calculo()

    this.props.onClose();

  };

  handleContestarData(e) {
    this.obs.alterar_data = e

    this.obs.contestacao.contestacao_calc_id = null
    this.obs.contestacao.contestacao_calc_id_devolucao = null

    this.obs.calc_selecionado = null

    this.obs.memoria_salvar = false
  }

  generateOptions(calcs: any) {

    let calc_options = []

    calc_options = calcs?.map((calc: any) => {

      calc._id = calc.calc_id
      calc.nome = calc.calc_name

      return calc

    });

    return calc_options

  }

  render() {

    let calcOptions: any = []

    calcOptions = this.generateOptions(this.props.sugerido_list)

    let calcText = !this.obs.calc_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_selecionado.nome.length >= 80 ? this.obs.calc_selecionado.nome.substring(0, 80) + "..." : this.obs.calc_selecionado.nome}`

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (<>
      <Dialog
        isOpen={true}
        onClose={this.props.onCancel}
        className="modal-contestacao"
      >
        <div className={Classes.DIALOG_HEADER}>
          <div style={{ display: "flex", width: "100%" }}>
            <h2 className="title-no-bottom">Contestar Cálculo</h2>
          </div>
        </div>

        <div className={Classes.DIALOG_BODY}>
          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%" }}
          >
            <tbody>
              <tr>
                <td>Valor produto</td>
                <td>
                  {numeral(parseFloat(this.props.item.valor_produto) || 0).format("$ 0,0.00")}
                </td>
                <td />
              </tr>
              <tr>
                <td>Valor ICMS Calculado</td>
                <td>
                  {numeral(parseFloat(this.props.item.valor_icms_ant) || 0).format("$ 0,0.00")}
                </td>
                <td />
              </tr>

              {!this.obs.alterar_data ?
                <>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Cálculo aplicado</td>
                    <td>
                      <FormGroup className="empresaSelect calcSelectSugerido">
                        <CalcSelect
                          items={calcOptions}
                          itemRenderer={renderCalcs}
                          itemPredicate={filterCalcs}
                          onItemSelect={(e: ICalc) => this.obs.calc_selecionado = e}
                          inputProps={{ placeholder: "Filtrar um Cálculo" }}
                          matchTargetWidth
                        >
                          <Button
                            text={calcText}
                            rightIcon="double-caret-vertical"
                            alignText={Alignment.LEFT} />
                        </CalcSelect>
                      </FormGroup>
                    </td>
                    <td />
                  </tr>

                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Valor Contestado</td>
                    <td>
                      <CurrencyInput
                        allowNegative
                        value={this.obs.contestacao.valor_contestado}
                        onChange={val => this.obs.contestacao.valor_contestado = val}
                      />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Trocar MVA</td>
                    <td>
                      <CurrencyInput
                        value={this.obs.contestacao.mva}
                        precision={3}
                        showIcon={false}
                        onChange={val => this.obs.contestacao.mva = val}
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <span
                        style={{
                          fontSize: 18,
                          marginRight: 10,
                          marginTop: 10,
                          display: "inline-block",
                        }}
                      >
                        %
                      </span>
                      <Button
                        onClick={(): void => this.obs.contestacao.mva = null}
                        className="btnLimpar"
                      >
                        Limpar
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Valor a Pagar</td>
                    <td>
                      {numeral(parseFloat(this.props.item.valor_icms_ant) - this.obs.contestacao.valor_contestado).format("$ 0,0.00")}
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Alterar data</td>
                    <td>
                      <DateInput
                        {...getMomentFormatter("DD/MM/YYYY")}
                        locale="pt-br"
                        dayPickerProps={dayPickerProps}
                        value={this.obs.contestacao.contestacao_data
                          ? new Date(this.obs.contestacao.contestacao_data)
                          : null}
                        onChange={val => this.obs.contestacao.contestacao_data = val}
                        placeholder="DD/MM/AAAA"
                        canClearSelection
                      />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Motivo</td>
                    <td>
                      <InputGroup
                        value={this.obs.contestacao.motivo}
                        onChange={(e: any) =>
                          this.obs.contestacao.motivo = e.target.value}
                      />
                    </td>
                    <td />
                  </tr>
                </>

                :

                <>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Alterar data</td>
                    <td>
                      <DateInput
                        {...getMomentFormatter("DD/MM/YYYY")}
                        locale="pt-br"
                        dayPickerProps={dayPickerProps}
                        value={this.obs.contestacao.contestacao_data
                          ? new Date(this.obs.contestacao.contestacao_data)
                          : null}
                        onChange={val => this.obs.contestacao.contestacao_data = val}
                        placeholder="DD/MM/AAAA"
                        canClearSelection
                      />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "middle" }}>Motivo</td>
                    <td>
                      <InputGroup
                        value={this.obs.contestacao.motivo}
                        onChange={(e: any) =>
                          this.obs.contestacao.motivo = e.target.value}
                      />
                    </td>
                    <td />
                  </tr>
                </>
              }
            </tbody>
          </HTMLTable>

          <MDBRow>
            <MDBCol md="3">
              <div className="consteta-produto-lote-btn">
                <Switch
                  label={"Salvar contestação"}
                  alignIndicator={Alignment.RIGHT}
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  disabled={this.obs.alterar_data}
                  checked={this.obs.memoria_salvar}
                  onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                />
                <Switch
                  label={"Apenas data"}
                  alignIndicator={Alignment.RIGHT}
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  onChange={(e: any) => this.handleContestarData(e.target.checked)}
                />
                {this.obs.memoria_salvar &&
                  <div style={{ display: "flex" }}>
                    <label style={{ width: 135 }}>
                      Memória CNPJ
                      <AppIcon
                        name="help"
                        className="pulse-notification-pgdas"
                        color="blue"
                        style={{ cursor: "pointer", marginLeft: 5 }}
                        onClick={(e) => this.obs.open_ajuda = true}
                      />
                    </label>
                    <Switch
                      alignIndicator={Alignment.RIGHT}
                      innerLabelChecked="Sim"
                      innerLabel="Não"
                      disabled={this.obs.alterar_data}
                      checked={this.obs.cnpj_memoria}
                      onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                    />
                  </div>
                }
              </div>
            </MDBCol>

            <MDBCol md="9">
              <div className="consteta-produto-lote-btn" style={{ textAlign: "right", marginTop: 10 }}>
                <Button text="Cancelar" onClick={() => this.props.onCancel()} style={{ marginRight: 10, height: "35px" }} />
                <Button
                  text="Contestar"
                  intent="primary"
                  onClick={this.handleConfirm}
                  style={{ height: "35px" }}
                />
              </div>
            </MDBCol>
          </MDBRow>
        </div>
      </Dialog>

      <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

        <b>Memória CNPJ:</b><br /><br />

        <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

        <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

      `} />

    </>);
  }
}
